import "./style.css"

<let/carouselIndex=0/>

<const/projects=input.projects/>
<const/currentProject=projects[carouselIndex]/>

<div class="projects-preview section-container">
  <h3>Projects</h3>

  <div class="carousel-wrapper">
    <button
      class="carousel-btn carousel-btn--prev"
      onClick() {
        carouselIndex = carouselIndex <= 0 ? projects.length - 1 : carouselIndex - 1;
      }
      aria-label="Previous project"
    >
      &#8249;
    </button>

    <if=currentProject>
      <div class="carousel-card">
        <project-card ...currentProject />
      </div>
    </if>

    <button
      class="carousel-btn carousel-btn--next"
      onClick() {
        carouselIndex = carouselIndex >= projects.length - 1 ? 0 : carouselIndex + 1;
      }
      aria-label="Next project"
    >
      &#8250;
    </button>
  </div>

  <div class="carousel-dots" role="tablist">
    <for|project, i| of=projects>
      <button
        role="tab"
        aria-selected=(i === carouselIndex)
        aria-label=`Go to project ${i + 1}`
        class=`carousel-dot ${i === carouselIndex ? 'carousel-dot--active' : ''}`
        onClick() { carouselIndex = i; }
      />
    </for>
  </div>

  <div class="projects-preview-footer">
    <a href="/projects" class="view-all-link">View All Projects →</a>
  </div>
</div>
